export const GET_CUSTOMER_LIST_SUCCESS = 'GET_CUSTOMER_LIST_SUCCESS'
export const SET_REFRESH_AG_TABLES = 'SET_REFRESH_AG_TABLES'